module.exports = __webpack_public_path__ + "img/pix.32182b40.png";